<div class="bidding-result d-flex flex-column">
  @if ((result$ | async) === biddingResult.success) {
    <div>
      <div class="result-message d-flex justify-content-center">
        <h1 class="success">{{ message$ | async }}</h1>
      </div>
      <div class="result-icon d-flex justify-content-center align-items-center">
        <fa-icon icon="check-circle" class="success" />
      </div>
    </div>
  } @else {
    <div class="result-message error d-flex flex-column align-items-center">
      <h3 class="text-center failed">Unsuccessful Bid</h3>
      <p class="text-center truncated-to-3-lines failed mt-3" title="{{ message$ | async }}">{{ message$ | async }}</p>
    </div>
  }

  <div class="bidding-summary pt-2">
    <app-bid-summary [property]="property$ | async" [bidAmount]="(bidData$ | async)?.BID_AMT" [bidAssistAmount]="(bidData$ | async)?.BID_ASSIST_AMT" />
  </div>
</div>

